<template>
    <div>
    <el-dialog
        title="新增"
        :visible.sync="diaFormVisble"
        width="50%"
        center
        >
         <div class="dialog">
           <el-form :model="addForm" ref="addForm" label-width="80px">
            <el-form-item label="職稱:">
              <el-radio-group v-model="addForm.role">
                  <el-radio v-for="item in options" :key="item.key" :label="item.label">
                      {{item.name}}
                  </el-radio>
              </el-radio-group>
              
            </el-form-item>
            <el-form-item label="網址:">
                 <el-select v-model="addForm.url">
                   <el-option v-for="item in urlItems"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
                   </el-option>
               </el-select>
               
            </el-form-item>
            
          
          
    
        
        
            <el-button @click="closeDia('addForm')">取 消</el-button>
            <el-button type="primary" @click="addPermission('addForm')">確 定</el-button>
            </el-form>
         </div>
    </el-dialog>
    
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'add',
        props: {
            diaFormVisble: Boolean
        },
        data() {
            return {
                addForm: {
                    role: null,
                    url: ''
                },
                 options: [
                    {label: 0, name: '管理者', key: 1},
                    {label: 1, name: '業務', key: 2},
                    {label: 2, name: '美容師', key: 3}
                ],
                       urlItems: [
        {key: 1 ,value: "/bundle/Add",label: "組合/任搭新增"},
        {key: 2 ,value: "/bundle/Update",label: "組合/任搭更新"},
        {key: 3 ,value: "/bundle/UpdateStatus",label: "組合/任搭更新狀態"},
		{key: 4 ,value: "/class/Add", label: "新增系列別"},
		{key: 5 ,value: "/class/Update", label: "更新系列別"},
		{key: 6 ,value: "/class/UpdateStatus", label: "更新系列別狀態"},
		{key: 7 ,value: "/class/List", label: "系列別列表"},
		{key: 8 ,value: "/coupon/Add", label: "新增禮卷"},
		{key: 9 ,value: "/coupon/List", label: "禮卷列表"},
		{key: 10 ,value: "/coupon/Detail", label: "禮卷詳細"},
		{key: 11 ,value: "/coupon/Update", label: "更新禮卷"},
		{key: 12 ,value: "/coupon/UpdateStatus", label: "更新禮卷狀態"},
		{key: 13 ,value: "/file/Add/product", label: "上傳產品檔案"},
		{key: 14 ,value: "/file/Add/bundle", label: "上傳組合/任搭檔案"},
		{key: 15 ,value: "/file/Add/order", label: "上傳訂單簽名檔案"},
		{key: 16 ,value: "/file/Add/notice", label: "上傳最新消息檔案"},
		{key: 17 ,value: "/member/Add", label: "新增會員"},
		{key: 18 ,value: "/member/List", label: "會員列表"},
		{key: 19 ,value: "/member/Detail", label: "會員詳細"},
		{key: 20 ,value: "/member/Update", label: "更新會員"},
		{key: 21 ,value: "/memberpoint/Add", label: "新增會員點數規則"},
		{key: 22 ,value: "/memberpoint/Detail", label: "會員點數規則詳細"},
		{key: 23 ,value: "/memberpoint/Update", label: "更新會員點數規則"},
		{key: 24 ,value: "/order/Add", label: "新增訂單"},
		{key: 25 ,value: "/order/AddPoint", label: "新增電子錢包訂單"},
		{key: 26 ,value: "/order/Share", label: "分享訂單業績"},
		{key: 27 ,value: "/order/Paid", label: "訂單付費"},
		{key: 28 ,value: "/order/Change", label: "訂單換貨"},
		{key: 29 ,value: "/order/Return", label: "訂單退貨"},
		{key: 30 ,value: "/order/List", label: "訂單列表"},
		{key: 31 ,value: "/order/Detail", label: "訂單詳細"},
		{key: 32 ,value: "/order/ChangeList", label: "訂單換貨列表"},
		{key: 33 ,value: "/order/ChangeDetail", label: "訂單換貨詳細"},
		{key: 34 ,value: "/order/ReturnDetail", label: "訂單退貨詳細"},
		{key: 35 ,value: "/order/ReturnList", label: "訂單退貨列表"},
	   	{key: 36 ,value: "/product/Add", label: "新增產品"},
	   	{key: 37 ,value: "/product/Update", label: "更新產品"},
	   	{key: 38 ,value: "/product/UpdateStatus", label: "更新產品狀態"},
	   	{key: 39 ,value: "/product/List", label: "產品列表"},
	   	{key: 40 ,value: "/product/Detail", label: "產品詳細"},
		{key: 41 ,value: "/pointgift/Add", label: "新增點數兌換禮品"},
		{key: 42 ,value: "/pointgift/List", label: "點數兌換禮品列表"},
		{key: 43 ,value: "/pointgift/Update", label: "更新點數兌換禮品"},
		{key: 44 ,value: "/pointgift/Delete", label: "點數兌換禮品詳細"},
		{key: 45 ,value: "/shop/Add", label: "新增店櫃"},
		{key: 46 ,value: "/shop/Update", label: "更新店櫃"},
		{key: 47 ,value: "/shop/UpdateStatus", label: "更新店櫃狀態"},
		{key: 48 ,value: "/shop/List", label: "店櫃列表"},
		{key: 49 ,value: "/shop/Detail", label: "店櫃詳細"},
		{key: 50 ,value: "/user/Add", label: "新增會員"},
		{key: 51 ,value: "/user/Update", label: "更新會員"},
		{key: 52 ,value: "/user/UpdateStatus", label: "更新會員狀態"},
		{key: 53 ,value: "/user/List", label: "會員列表"},
		{key: 54 ,value: "/user/Detail", label: "會員詳細"},
		{key: 55 ,value: "/user/ForceResetPassword", label: "會員密碼變更"},
		{key: 56 ,value: "/vip/Levelup", label: "會員升級"},
		{key: 57 ,value: "/vip/Extend", label: "會員續卡"},
		{key: 58 ,value: "/notice/Add", label: "新增最新消息"},
		{key: 59 ,value: "/notice/Update", label: "更新最新消息"},
		{key: 60 ,value: "/notice/UpdateStatus", label: "更新最新消息狀態"},
		{key: 61 ,value: "/notice/List", label: "最新消息列表"},
		{key: 62 ,value: "/notice/Detail", label: "最新消息詳細"}
	       ]
            }
        },
        computed: mapGetters(["getPermissionError", "getPermissionMsg"]),
        methods: {
            ...mapActions(['addPermission']),
            async addPermission(formName){
                const data = {role: this.addForm.role, url: this.addForm.url}
                await this.$store.dispatch('addPermission', data)
                if(this.getPermission == true){
                    this.$notify({
                        title: '失敗',
                        message: this.getPermissionMsg,
                        type: 'error',
                        duration: '4500',
                        position: 'top-right'
                    });
                    
                }else {
                    this.$notify({
                        title: '成功',
                        message: '新增權限成功',
                        type: 'success',
                        duration: '4500',
                        position: 'top-right'
                    });
                    this.$refs[formName].resetFields()
                    this.$emit('closeDia')
                }
            },
            closeDia(formName){
               this.$emit('closeDia')
                this.$refs[formName].resetFields()
            },
           
            
        },
    }
</script>

<style lang="scss" scoped>
    dialog {
    height: 60vh;
    overflow: auto;
}
</style>